<template>
  <div>
    <dialog-component
      :dialog-title="deviceDetails.name"
      :dialogVisible.sync="visible"
      :width="width"
      @dialogClose="handleClose"
      append-to-boby
      center>
      <div slot="content">
        <DeviceDetailDialogHeader :alarmInfoList="alarmInfoList" :device-info="deviceInfo"></DeviceDetailDialogHeader>
        <div style="height: 582px;margin-top: 4px;overflow-y: auto">
          <component v-if="visible" :is="component" ref="component" :alarmInfoList="alarmList" :deviceInfo="deviceDetails"></component>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import DialogHeader from "@/components/device_details/comp/DialogHeader";
import DialogComponent from "@/components/DialogComponent";
import DeviceDetailDialogHeader from "@/components/device_details/comp/DeviceDetailHeader";

export default {
  name: "DeviceDetailDialog",
  components: {DialogHeader, DialogComponent, DeviceDetailDialogHeader},
  props: ['dialogVisible', 'deviceInfo', 'alarmInfoList', 'width'],
  watch: {
    dialogVisible: {
      handler(val) {
        console.log(this.deviceInfo , 'deviceInfo-------')
        this.visible = val
      }
    },
    alarmInfoList: {
      handler(val) {
        this.alarmList = val
      }
    },
    deviceInfo: {
      handler(val) {
        this.deviceDetails = val
        if (this.visible) {
          if (val.detailUrl === "div:TemperatureHumidity") {
            this.component = null;
          } else {
            this.component = () => import('@/components/device_details/' + val.detailUrl + '.vue');
            // this.component = () => import('@/components/device_details/' + 'DVR' + '.vue');
          }
        }
      }
    },
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('dialogClose', this.visible)
      this.$refs.component.$destroy()
    }
  },
  data() {
    return {
      visible: false,
      deviceDetails: {
        deviceName: '',
        categoryName: '',
        brandName: '',
        modelName: '',
      },
      component: null,
      alarmList: []
    };
  }
}
</script>

<style scoped>

</style>
